import React from 'react';
import { usePermissions } from '../contexts/PermissionContext';
import NoPermission from './NoPermission';

const PermissionGate = ({ 
  children, 
  requiredPermissions = [], 
  requiredRoles = [], 
  fallback = null,
  showFallback = true,
  customMessage = null
}) => {
  const { hasPermission, hasAnyPermission, isRole, isAnyRole, loading } = usePermissions();

  // Show loading state while permissions are being fetched
  if (loading) {
    return null; // or a loading spinner
  }

  // Check role-based access
  if (requiredRoles.length > 0) {
    if (!isAnyRole(requiredRoles)) {
      if (showFallback) {
        return fallback || (
          <NoPermission 
            title="Access Denied"
            message={customMessage || `You need one of these roles: ${requiredRoles.join(', ')}`}
          />
        );
      }
      return null;
    }
  }

  // Check permission-based access
  if (requiredPermissions.length > 0) {
    if (!hasAnyPermission(requiredPermissions)) {
      if (showFallback) {
        return fallback || (
          <NoPermission 
            title="Access Denied"
            message={customMessage || `You need one of these permissions: ${requiredPermissions.join(', ')}`}
          />
        );
      }
      return null;
    }
  }

  // If no requirements or all requirements met, render children
  return children;
};

export default PermissionGate; 